import { gql } from '@apollo/client';
import PATIENT_RETURN_FRAGMENT from '../fragments/patientReturnFragment';

const UPDATE_PATIENT_RETURN_MUTATION = gql`
  mutation updatePatientReturn($input: UpdatePatientReturnInput!) {
    updatePatientReturn(input: $input) {
      isSuccess
      message
      patientReturn {
        ...PatientReturnFragment
      }
    }
  }

  ${PATIENT_RETURN_FRAGMENT}
`;

export default UPDATE_PATIENT_RETURN_MUTATION;
